import AiCourseCreationModal from './AiCourseCreationModal'

export default AiCourseCreationModal
